<template>
  <div
    class="w-full px-4 mx-auto max-w-7xl flex flex-col items-center justify-center text-center h-100 sm:px-8 md:px-8 md:mb-8"
    id="404"
  >
    <img
      src="@/assets/images/group-3.png"
      srcset="
        @/assets/images/group-3@2x.png 2x,
        @/assets/images/group-3@3x.png 3x
      "
      class="Group-3"
      alt=""
    />
    <h3 class="text-28p text-gray-800 font-semibold">
      APIConnect is currently down for maintenance.<br />
      We expect to be back soon. Thank you for your patience.
    </h3>
  </div>
</template>

<script>
export default {
  name: "Maintenance",
  computed: {},
};
</script>

<style lang="postcss" scoped>
img.Group-3 {
  width: 136.1px;
  height: 150px;
  margin: 80px 651.9px 40px 652px;
  object-fit: contain;
}
.APIConnect-is-curren {
  margin: 40px 288px 0;
  font-size: 28px;
  font-weight: 600;
  color: #414456;
}
</style>
